import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ArrowUpRight } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0071e3] text-white">
      {/* Main Footer */}
      <div className="container-apple py-16 lg:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 lg:gap-12">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-4 lg:col-span-1 mb-8 lg:mb-0">
            <div className="flex items-center mb-6">
              <img 
                src="/weqasa-logo.png" 
                alt="WEQASA" 
                className="h-10 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-[14px] text-white/80 leading-relaxed max-w-xs">
              La piattaforma premium per la compravendita immobiliare in Italia.
            </p>
          </div>

          {/* Esplora */}
          <div>
            <h4 className="text-[12px] font-semibold text-white uppercase tracking-wider mb-5">
              Esplora
            </h4>
            <ul className="space-y-3">
              {[
                { to: '/', label: 'Home' },
                { to: '/immobili', label: 'Immobili' },
                { to: '/come-funziona', label: 'Come Funziona' },
                { to: '/servizi-ai', label: 'Servizi AI' },
                { to: '/faq', label: 'FAQ' },
              ].map((link) => (
                <li key={link.to}>
                  <Link 
                    to={link.to} 
                    className="text-[14px] text-white/80 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Per Te */}
          <div>
            <h4 className="text-[12px] font-semibold text-white uppercase tracking-wider mb-5">
              Per Te
            </h4>
            <ul className="space-y-3">
              {[
                { to: '/registrati/proprietario', label: 'Vendi Immobile' },
                { to: '/registrati/acquirente', label: 'Cerca Casa' },
                { to: '/registrati/agente', label: 'Diventa Agente' },
                { to: '/contatti', label: 'Contattaci' },
              ].map((link) => (
                <li key={link.to}>
                  <Link 
                    to={link.to} 
                    className="text-[14px] text-white/80 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legale */}
          <div>
            <h4 className="text-[12px] font-semibold text-white uppercase tracking-wider mb-5">
              Legale
            </h4>
            <ul className="space-y-3">
              {[
                { to: '/privacy-policy', label: 'Privacy Policy' },
                { to: '/termini', label: 'Termini di Servizio' },
                { to: '/cookies', label: 'Cookie Policy' },
              ].map((link) => (
                <li key={link.to}>
                  <Link 
                    to={link.to} 
                    className="text-[14px] text-white/80 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contatti */}
          <div>
            <h4 className="text-[12px] font-semibold text-white uppercase tracking-wider mb-5">
              Contatti
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 text-white/80 mt-0.5 flex-shrink-0" strokeWidth={1.5} />
                <span className="text-[14px] text-white/80">
                  Via Roma 123<br />00100 Roma (RM)
                </span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="h-4 w-4 text-white/80 flex-shrink-0" strokeWidth={1.5} />
                <a href="tel:+39061234567" className="text-[14px] text-white/80 hover:text-white transition-colors">
                  +39 06 1234567
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="h-4 w-4 text-white/80 flex-shrink-0" strokeWidth={1.5} />
                <a href="mailto:info@weqasa.it" className="text-[14px] text-white/80 hover:text-white transition-colors">
                  info@weqasa.it
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/20">
        <div className="container-apple py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-[12px] text-white/80">
              © {currentYear} WEQASA S.r.l. Tutti i diritti riservati. P.IVA 12345678901
            </p>
            <div className="flex items-center space-x-2 text-[12px] text-white">
              <span>weQasa from</span>
              <img 
                src="/era-group-logo.png" 
                alt="ERA Group" 
                className="h-6 w-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
